import React, {useState} from "react";
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer";
import { useForm ,Controller} from "react-hook-form";
import PhoneInput from 'react-phone-number-input';
import './contact_style.css'
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Form, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
const InvestorRelation = ()=> {

    const [errorMessage, setErrorMessage] = useState({error: false, header: '', message: ''});
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const modalContent = {
        header: "Message Received!",
        body: "Thank you for reaching out to us. Our team has received your message and will get back to you shortly.",
        variant: "success",
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('First Name is required'),
        lastName: Yup.string().required('Last Name is required'),
        phone: Yup.string()
            .required('Phone number is required').min(12, 'Phone number must be at least 10 digits'),
        email: Yup.string().email('Email is invalid').required('Email is required'),
        message: Yup.string().required('Message is required'),
    });

    const { register, handleSubmit, formState: { errors }, reset, control } = useForm({
        resolver: yupResolver(validationSchema)
    });
    
    const onSubmit = async (data) => {
        try {
            setLoading(true);
            setShowAlert(false);

            //Post to the same-origin serverless function, which emails the team
            const { data: response } = await axios.post('/api/contact-submit', {
                first_name: data.firstName || 'First Name',
                last_name: data.lastName || 'Last Name',
                phone_number: data.phone || 'Phone Number',
                email_address: data.email || 'Email Address',
                message: data.message || 'Message',
               source: 'investor'
             });
   
            //Check if the form was submitted successfully
            if (response.success === true) {
                setErrorMessage({error: false, header: '', message: ''});
                setShowAlert(true);
                reset();
                setLoading(false);
            } else if (response.success === true && response.data?.message) {
                //We got a 200 response but with an error message
                console.error('Error submitting form:', response.data.message);
                setErrorMessage({error: true, header: 'Error!', message: response.data.message, variant: 'danger'});
                setShowAlert(true);
                setLoading(false);
            }
        } catch (error) {
            if (error.response?.data?.message) {
                console.error('Error submitting form:', error.response.data.message);
                setErrorMessage({error: true, header: 'Error!', message: error.response.data.message, variant: 'danger'});
                setShowAlert(true);
            } else {
                console.error('Error submitting form:', error);
            }
            setLoading(false);
        }
    };
    return (
        <>
          <AIheader/>
            <section className="contactPageMain" id="">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {/* START Left Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactPageLeft">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/contact-us">Contact Us</Link></li>
                                    <img className="" src="/img/arrow-right-nav.svg" alt="arrow icon"/>
                                    <li className="breadcrumb-item active" aria-current="page">Investor Relations</li>
                                </ol>
                            </nav>
                            <h2>Investor Relations</h2>
                            <Alert variant={errorMessage.error ? errorMessage.variant : modalContent.variant} show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                                <Alert.Heading>{errorMessage.error ? errorMessage.header : modalContent.header}</Alert.Heading>
                                <p>
                                    {errorMessage.error ? errorMessage : modalContent.body}
                                </p>
                            </Alert>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="first_name">First Name<span className="required">*</span></Form.Label>
                                            <Form.Control required type="text" id="first_name" placeholder='Enter first name' name="waitlist[first_name]" {...register('firstName')}
                                            disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.firstName?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="last_name">Last Name<span className="required">*</span></Form.Label>
                                            <Form.Control required type="text" id="last_name" placeholder='Enter last name' name="lastName" {...register('lastName')}
                                            disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.lastName?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    

                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="email_address">Email address<span className="required">*</span></Form.Label>
                                            <Form.Control required type="email" id="email_address" placeholder='Enter your email' name="email" {...register('email')}
                                                isInvalid={!!errors.email} disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="col-lg-6">  
                                    <Form.Group className="mb-3">
                                            <Form.Label htmlFor="phone_number">
                                                Phone Number<span className="required">*</span>
                                            </Form.Label>
                                            <Controller
                                                name="phone"
                                                control={control}
                                                disabled={loading}
                                                rules={{
                                                    required: "Phone number is required",
                                                    validate: (value) => (value && value.length >= 12) || "Phone number must be valid",
                                                }}
                                                render={({ field }) => (
                                                    <PhoneInput
                                                        disabled={loading}
                                                        {...field}
                                                        id="phone_number"
                                                        limitMaxLength={true}
                                                        defaultCountry="US"
                                                        placeholder="XXX-XXX-XXX"
                                                        onChange={(value) => field.onChange(value)} // Ensure React Hook Form value updates
                                                        value={field.value || ''}
                                                    />
                                                )}
                                            />
                                            {errors.phone && (
                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                    {errors.phone.message}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="mb-4">
                                            <label className="form-label">Message<span className="required">*</span></label>
                                            <textarea disabled={loading}
                                            {...register("message", { required: true })}
                                            className="form-control"
                                            placeholder="Let us know how we can assist you today..."
                                            rows="4"
                                            ></textarea>
                                            {errors.message && (
                                            <div className="text-danger small">Message is required</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <Button disabled={loading} type="submit" className="btn submit w-100">{loading ? "Submitting..." : "Submit"}</Button>
                                    </div>
                                </div>
                            </Form>
                            </div>
                        </div>
                        {/* END Left Section */}

                        {/* START Right Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactPageRight">
                                <div className="contactPageRightInner">
                                    <h2>We’re here to help.</h2>
                                    <p>Workflows and tools built to help your rental business thrive. Let us know how we can assist you.</p>
                                </div>
                                
                                <div className='contactLogoOuter'>
                                    <div className="contactLogoInner contactLogoGreen">
                                        <a href="/rentdirect" alt="Go to Rent Direct">
                                        <div className="green_overlay"></div>
                                            <figure><img src="/img/rent_direct_logo.png" alt="Rent Direct logo"/></figure>
                                        </a>
                                    </div>
                                    
                                    <div className="contactLogoInner contactLogoSky">
                                        <a href="/rent-id" alt="Go to Rent ID">
                                            <div className="sky_overlay"></div>
                                            <figure> <img src="/img/rent_id_logo.svg" alt="Rent ID logo"/></figure>
                                        </a>
                                    </div>

                                    <div className="contactLogoInner contactLogoRed">
                                        <a href="/rentshield" alt="Go to Rent Shield">
                                            <div className="red_overlay"></div>
                                            <figure><img src="/img/rent_shield_logo.png" alt="Rent Shield logo"/></figure>
                                        </a>
                                    </div>
            
                                    <div className="contactLogoInner contactLogoPurple">
                                        <a href="/rentsuccess" alt="Go to Rent Success">
                                            <div className="purple_overlay"></div>
                                            <figure><img src="/img/rent_success_logo.png" alt="Rent Success logo"/></figure>
                                        </a>
                                    </div>


                                    <div className="contactLogoInner contactLogowhite">
                                        <a href="/rentai" alt="Go to Rent AI">
                                            <div className="white_overlay"></div>
                                            <figure> <img src="/img/rent_ai_logo.svg" alt="Rent AI logo"/></figure>
                                        </a>
                                    </div>
                                    <div className="contactLogoInner contactLogoYellow">
                                        <a href="/rentacademy" alt="Go to Rent Academy">
                                            <div className="yellow_overlay"></div>
                                            <figure> <img src="/img/rent_academy_logo.png" alt="Rent Academy logo"/></figure>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* END Right Section */}
                    </div>
                </div>
            </section>
        <Footer/>
        </>
    )
}
export default InvestorRelation;